import React, { Fragment } from 'react';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Box from '@mui/material/Box';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import InfoIcon from '@mui/icons-material/Info';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { useTheme } from '@mui/material';

const PREFIX = 'BuildingsCheckList';

const classes = {
    root: `${PREFIX}-root`,
    checkbox: `${PREFIX}-checkbox`,
    paper: `${PREFIX}-paper`,
    filterTextPrimary: `${PREFIX}-filterTextPrimary`,
    filterTextSecondary: `${PREFIX}-filterTextSecondary`,
    subtitle: `${PREFIX}-subtitle`,
    checkboxCampus: `${PREFIX}-checkboxCampus`
};

const Root = styled('div')((
    {
        theme
    }
) => ({
    [`& .${classes.root}`]: {
        width: '100%',
    },

    [`& .${classes.checkbox}`]: {
        width: '20px',
        height: '20px'
    },

    [`& .${classes.paper}`]: {
        width: '80%',
        maxHeight: 450,
    },

    [`& .${classes.filterTextPrimary}`]: {
        fontSize: theme.typography.pxToRem(14), /*size of the title  checkbox menu*/
    },

    [`& .${classes.filterTextSecondary}`]: {
        fontSize: theme.typography.pxToRem(13), /*size of the text in the checkbox selector*/ 
    },

    [`& .${classes.subtitle}`]: {
        fontSize: theme.typography.pxToRem(13), /*size of the selected item in the checkbox menu*/
        textOverflow: 'ellipsis',
        width:'300px',
        overflow:'hidden',
        whiteSpace:'nowrap'
    },

    [`& .${classes.checkboxCampus}`]: {
        width: '20px',
        height: '20px',
        marginLeft:'15px'
    }
}));


function BuildingsCheckList(props) {

    const {
        value,
        open,
        handleClickListItem,
        handleOk,
        handleChange,
        handleChangeAll,
        handleChangeCampus,
        checkboxes,
        checkAll,
        checkCampus,
        required,
        height
    } = props;
    const theme = useTheme();

    var buildingJson = {};
    for (let key in checkCampus) {
        buildingJson[key] = [];
    }

    for (var i = 0; i < checkboxes.length; i++) {
        buildingJson[checkboxes[i].campus].push(
            <Root>
            <FormControlLabel
                key={i}
                control={<Checkbox id={checkboxes[i].id} sx={{marginLeft: 1.875}} checked={checkboxes[i].checked} onChange={handleChange} value={checkboxes[i].name} />}
                label={<Typography component={'span'} sx={{fontSize: theme.typography.pxToRem(14)}}>{checkboxes[i].name}</Typography>}
                disabled={(checkboxes[i].disabled || checkboxes[i].serverDisabled)}
            />
            {(checkboxes[i].disabled || checkboxes[i].serverDisabled) ? 
                <Tooltip title={checkboxes[i].errroMessage}>
                <IconButton disableFocusRipple="true" disableRipple="true" size="small" >
                    <InfoIcon/>
                </IconButton>
                </Tooltip>
            : null
            }
            </Root>
        );
    }



    var requiredAsterisk = null;
    var secondaryText = <div className={classes.subtitle}>{value}</div>;
    if (required) {
        requiredAsterisk = <Box color="error.main"> *</Box>;
        if (value === "Ninguno") {
            secondaryText = <Typography  component={'div'} className={classes.subtitle}>
                <Box color="error.main">{value}</Box>
            </Typography>;
        }
    }
    var maxHeight = height < 450 ? '95%' : 450;
    return (
        <Root>
            <Dialog
                onClose={(event, reason) => {
                    //disable backdrop click
                }}
                disableEscapeKeyDown
                maxWidth="xs"
                aria-labelledby="confirmation-dialog-title"
                open={open}
                sx={{
                    '& .MuiPaper-root': {
                        width: '100%',
                        maxHeight: maxHeight,
                    },
                }}
            >
                <DialogTitle id="confirmation-dialog-title" >
                    <Typography fontWeight="fontWeightMedium" component={'div'} variant="body1">Seleccione edificio(s)</Typography>
                </DialogTitle>
                <DialogContent dividers>
                    <div className={classes.root}>
                        <FormGroup >
                            <FormControlLabel

                                control={<Checkbox id="all" checked={checkAll} onChange={handleChangeAll} value="all" />}
                                label={<Typography fontWeight="fontWeightMedium"  component={'div'} sx={{fontSize: theme.typography.pxToRem(13)}}>Todos</Typography>}
                            />
                        </FormGroup>
                        {
                            Object.keys(buildingJson).map((campus) =>{
                                return( 
                                    <Accordion
                                        sx={{
                                            '& .MuiPaper-root': {
                                                width: '100%'
                                            },
                                        }}
                                    >
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-label="Expand"
                                            aria-controls="additional-actions2-content"
                                            id="additional-actions2-header"
                                        >
                                            <FormControlLabel
                                                aria-label="Acknowledge"
                                                onClick={event => event.stopPropagation()}
                                                onFocus={event => event.stopPropagation()}
                                                control={<Checkbox id="allcampus" checked={checkCampus[campus]} onChange={handleChangeCampus} value={String(campus)} />}
                                                label={<Typography sx={{fontSize: theme.typography.pxToRem(13)}}>{campus}</Typography>}
                                            />
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <Typography component={'div'} color="textSecondary">
                                                <FormGroup>
                                                    {buildingJson[campus]}
                                                </FormGroup>
                                            </Typography>
                                        </AccordionDetails>
                                    </Accordion>
                                )
                            })
                        }
                        
                        
                    </div>

                </DialogContent>
                <DialogActions>
                    <Button onClick={handleOk} color="primary">
                        Aplicar
                    </Button>
                </DialogActions>
            </Dialog>

            <ListItemButton
                button
                divider
                aria-haspopup="true"
                aria-controls="buiding-menu"
                aria-label="buildings"
                onClick={handleClickListItem}
                role="listitem"
                selected = {open}
                sx={{
                    paddingLeft: 1.25,
                    paddingRight: 1.25,
                }}
            >
                <ListItemText primary={
                    <Typography component={'div'} sx={{fontSize: theme.typography.pxToRem(14)}}>
                        <div style={{ display: "flex" }}>
                            Seleccione edificio(s) {requiredAsterisk}
                        </div>

                    </Typography>
                } secondary={secondaryText} />
            </ListItemButton>
        </Root>
    );
}

export default BuildingsCheckList;